import Vue from 'vue';
import { cloneDeep } from 'lodash';
// import moment from 'moment';

const INIT_DATA = {
  currentPage: 1,
  perPage: 10,
  totalRows: 0,
  // フィルタリング条件保存
  filter: {
    name: '',
    authes: '',
  },
  // No.15: 画面戻り時のソート維持
  sortBy: 'kana',
  sortDesc: false,
};

export default {
  namespaced: true,
  state: cloneDeep(INIT_DATA),
  mutations: {
    setFilter(state, param) {
      Vue.set(state.filter, param.key, param.value);
      // No.15: 検索条件変更時はデフォルトソート(kana 昇順)に戻す
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
    setCurrentPage(state, page) {
      state.currentPage = page;
    },
    setPerPage(state, page) {
      state.perPage = page;
    },
    setTotalRows(state, value) {
      state.totalRows = value;
    },
    initFilter(state) {
      Vue.set(state.filter, 'name', '');
      Vue.set(state.filter, 'authes', '');
      state.currentPage = 1;
      state.perPage = 10;
      // ここは位置段階の検索なので、総数の初期化を行わない
      // state.totalRows = 0;
      // No.15: ヘッダー経由リセット時もデフォルトソート(kana 昇順)に戻す
      state.sortBy = 'kana';
      state.sortDesc = false;
    },
    setSortBy(state, v) {
      state.sortBy = v;
    },
    setSortDesc(state, v) {
      state.sortDesc = v;
    },
    setSort(state, { sortBy, sortDesc }) {
      state.sortBy = sortBy;
      state.sortDesc = sortDesc;
    },
  },
  actions: {
  },
};
